import { render, staticRenderFns } from "./portfolioupload.vue?vue&type=template&id=76c43eb4&scoped=true&"
import script from "./portfolioupload.vue?vue&type=script&lang=js&"
export * from "./portfolioupload.vue?vue&type=script&lang=js&"
import style0 from "./portfolioupload.vue?vue&type=style&index=0&id=76c43eb4&lang=scss&scoped=true&"
import style1 from "./portfolioupload.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c43eb4",
  null
  
)

export default component.exports